import React, { forwardRef } from "react";
import styled from "styled-components";
import classNames from "classnames";
import IBuildrProps from "../../../utilities/IBuildrProps";

const Stars = styled(forwardRef(({ className, cmsId, editorClassObj }: IBuildrProps, ref: any) => {
    return (
        <div ref={ref} data-id={cmsId} className={classNames(editorClassObj, "d-inline-block position-relative", className)}>
            <div className="stars">
                <span className="star"></span>
                <span className="star"></span>
                <span className="star"></span>
                <span className="star"></span>
                <span className="star"></span>
            </div>
            <div className="stars star-overlay">
                <span className="star full"></span>
                <span className="star full"></span>
                <span className="star full"></span>
                <span className="star full"></span>
                <span className="star full"></span>
            </div>
        </div>
    );
}))<{ score: string }>`
    .star {
        background: url(https://www.macu.com/MACU/Images/review-star-gray.svg) no-repeat center;
        width: 21px;
        height: 20px;
        position: relative;
        display: inline-block;
        margin: 0 1px;

        &.full {
            background: url(https://www.macu.com/MACU/Images/review-star-yellow.svg) no-repeat center;
        }
    }

    .star-overlay {
        position: absolute;
        display: inline-block;
        top: 0px;
        left: 0px;
        width: ${props => (Number(props.score) / 5) * 100}%;
        overflow: hidden;
        white-space: nowrap;
        background: white;
    }
`;

export default Stars;
(global as any).Stars = Stars;